import React, { useState } from 'react';
import { withStyles } from '@mui/styles';
import LanguageIcon from '@mui/icons-material/LanguageOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';

const styles = () => {
  return {
    LanguageToggleParent: {
      zIndex: 999,
      right: '88%',
      bottom: '15%',
      height: '50px',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '6px',
      cursor: 'pointer',
    },
    iconStyle: {
      fontSize: '20px',
      color: '#aaa',
    },
    dropdown: {
      background: 'white',
      padding: '10px',
      border: '1px solid #e3e3e3',
      bottom: 0,
      boxShadow: '1px 1px #ccc',
      width: 140,
      borderRadius: '5px',
      position: 'absolute',
      color: 'darkslategray',
      left: '6%',
      lineHeight: '20px',
      fontSize: 'smaller',
    },
    dropdown_ul: {
      listStyle: 'none',
      padding: '0px 5px',
      margin: '0 15px',
    },
    dropdown_ul_li: {
      fontSize: '1em',
      textAlign: 'left',
      fontWeight: '500',
      cursor: 'pointer',
    },
    hidden: {
      display: 'none',
    },
  };
};

const LanguageToggle = ({ classes, box, ...props }) => {
  const { i18n } = useTranslation();
  const [toggle, setToggle] = useState(false);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setToggle((prev) => !prev);
  };

  return (
    <div className={classes.LanguageToggleParent}>
      <div onClick={() => setToggle((prev) => !prev)}>
        <LanguageIcon className={classes.iconStyle} />
        <ArrowForwardIosIcon
          className={classes.iconStyle}
          style={{ height: '0.7em', marginLeft: '-6px', marginBottom: '3px' }}
        />
      </div>
      <div className={toggle ? classes.dropdown : classes.hidden}>
        {toggle && (
          <ul className={classes.dropdown_ul}>
            <li
              className={classes.dropdown_ul_li}
              onClick={() => changeLanguage('en')}
            >
              English - EN
            </li>
            <li
              className={classes.dropdown_ul_li}
              onClick={() => changeLanguage('fr')}
            >
              Français - FR
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(LanguageToggle);



// WEBPACK FOOTER //
// ./src/components/common/LanguageToggle.js